import Modal from "../../components/Modal/Modal";
import React from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";
import { InfoIcon, TitleModal, WalletAddress, WalletAddressQR, WalletAddressTitle, WalletAddressValue, WalletDetailNotify, WalletDetailNotify2, WalletDetailRow, WalletRow, WalletRowLeft } from "./styles";
import { Copy } from "../../components/Copy";
import QRCode from "react-qr-code";
import { useWindowSize } from "../../hook/useWindowSize";
import { Divider } from "antd";
import { TabItem } from "../../components/Tab";
import FormButton from "../../components/FormCustom2/Button";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalDeposit = ({ value, ...props }) => {
  const { T } = useApp();
  const size = useWindowSize()
  const onClose = () => {
    props.onClose();
  };


  return (
    <Modal onClose={onClose} w>
      <Modal.ModalBg onClose={onClose} />
      <Modal.Container width="850px" onClose={onClose}>
        <ContentWaper>
          <div>
            <TitleModal>{T("Deposit")}</TitleModal>
          </div>
          <div className="mt-[20px] lg:mt-[58px]">
            <div>
              <WalletDetailNotify2>
                <InfoIcon className="hidden lg:block" />
                <div
                  dangerouslySetInnerHTML={{
                    __html: T("wallet.detail.notify")
                      .split("{coin}")
                      .join(value.coin)
                      .split("{coin_name}")
                      .join(T(value.cName)),
                  }}
                />
              </WalletDetailNotify2>

              <div className="mt-[25px] lg:mt-[50px] flex flex-col items-center">
                <WalletAddressQR>
                  <QRCode size={130} value={value?.address || ""} />
                </WalletAddressQR>
                <WalletAddressTitle className="mt-[30px]">{T("Your address")}</WalletAddressTitle>
                <WalletAddress>
                  <WalletAddressValue style={{ maxWidth: 478 }}>
                    <Copy splitEnd={0} splitFontLg={size.width < 1024 ? 25 : 100} text={value?.address || ""} />
                  </WalletAddressValue>
                </WalletAddress>
              </div>
              <Divider className="mt-[52px] hidden lg:block" />
              <div className="mt-[48px] flex justify-center">
                <FormButton
                  className={"black"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    props.onClose();
                  }}
                >
                  {T("Cancel")}
                </FormButton>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container>
    </Modal>
  );
};
